import { render } from "./DWHIcon.vue?vue&type=template&id=65d50726"
import script from "./DWHIcon.vue?vue&type=script&lang=js"
export * from "./DWHIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__